import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {Lien} from '@app/titles/models/lien';
import {User} from '@ui/types/user';
import {debridAlldebrid} from '@common/auth/alldebrid';

export interface ResponseDownload extends BackendResponse {
  lien: Lien;
  directDL: string;
  debrided: boolean;
  error: string;
}

export function useDownload(
  id: number,
  enabled: boolean,
  user?: User,
  token?: string,
) {
  return useQuery({
    queryKey: ['liens', id],
    enabled,
    queryFn: () => fetchDownload(id, user, token),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

async function fetchDownload(id: number, user?: User, token?: string) {
  const result = await apiClient
    .post<ResponseDownload>(`liens/${id}/download`, {token})
    .then(response => response.data);

  if (
    user?.IsPremium &&
    user?.more_info.debrid_link &&
    user?.debridors.length &&
    user?.debridors.find(debridor => debridor.provider === 2) &&
    result.debrided === false &&
    result.lien.id_host !== 2
  ) {
    const alldebrid = user?.debridors.find(debridor => debridor.provider === 2);
    if (alldebrid) {
      const debridResult = await debridAlldebrid(
        alldebrid.api,
        result.lien.lien,
      );
      if (debridResult.success && debridResult.link) {
        return {
          ...result,
          directDL: debridResult.link,
          debrided: true,
        };
      } else {
        return {
          ...result,
          error: debridResult.error,
        };
      }
    }
  }
  return result;
}
